import React from 'react';
import PropTypes from 'prop-types';
import { Typography, Box } from '@material-ui/core';
import { useProductInstructionsStyles } from './styles';

const ProductCardInstructions = ({ ...props }) => {
  const { category } = props;
  const classes = useProductInstructionsStyles();

  return (
    <Box
      display="flex"
      alignItems="center"
      flexDirection="column"
      className={classes.container}
    >
      {category &&
        category.categoryTips &&
        category.categoryTips.map((tip, index) => (
          <React.Fragment key={index}>
            <Typography className={classes.title}>{tip.title}</Typography>
            <Typography className={classes.subtitle}>{tip.subtitle}</Typography>
          </React.Fragment>
        ))}
    </Box>
  );
};

ProductCardInstructions.propTypes = {
  category: PropTypes.object.isRequired,
};

export default ProductCardInstructions;
